import React from "react";
import Image from "../assets/profilepic.jpg";
import { Link } from "react-scroll";
import {
  AiFillTwitterCircle,
  AiFillInstagram,
  AiFillLinkedin,
  AiFillGithub,
} from "react-icons/ai";
import { TypeAnimation } from "react-type-animation";
import VerifiedIcon from "@mui/icons-material/Verified";
import { motion } from "framer-motion";
import { fadeIn } from "../Transitions";

const Home = () => {
  return (
    <section
      className="min-h-[85vh] lg:min-h-[78vh] flex items-center"
      id="home"
    >
      <div className="container mx-auto">
        <div className="flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12">
          <div className="flex-1 text-center lg:text-left">
            <motion.h1
              variants={fadeIn("up", 0.3)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="text-[55px] font-bold leading-[0.8] lg:text-[60px]"
            >
              {/* DELVIN <span>REYES</span> */}
            </motion.h1>
            <motion.div
              variants={fadeIn("up", 0.5)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="mb-6 text-[30px] lg:text-[40px] font-semibold py-4"
            >
              <span className="text-white mr-2">I am a</span>
              <TypeAnimation
                sequence={[
                  "Dancer",
                  2000,
                  "Photographer",
                  2000,
                  "Software Engineer",
                  2000,
                ]}
                speed={50}
                className="bg-gradient-to-r from-gray-200 via-gray-400 to-gray-600 bg-clip-text text-transparent"
                wrapper="span"
                repeat={Infinity}
              />
            </motion.div>
            <motion.p
              variants={fadeIn("up", 0.6)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="mb-8 max-w-lg mx-auto lg:mx-0"
            >
              Follow me on Vero @DelvinReyes{" "}
              <VerifiedIcon
                fontSize="small"
                sx={{ fontSize: 12 }}
                className="mb-1 text-[#63a9ff]"
              />
            </motion.p>
            <motion.div
              variants={fadeIn("up", 0.8)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0"
            >
              <button className="btn btn-lg">
                <Link
                  to="contact"
                  activeClass="active"
                  smooth={true}
                  spy={true}
                >
                  Contact me
                </Link>
              </button>
              <button className="bg-gradient-to-r from-gray-200 via-gray-400 to-gray-600 bg-clip-text text-transparent">
                <Link
                  to="photography"
                  activeClass="active"
                  smooth={true}
                  spy={true}
                >
                  My Work
                </Link>
              </button>
            </motion.div>
            <motion.div
              variants={fadeIn("up", 0.3)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="flex text-[20px] gap-x-6 max-w-max mx-auto lg:mx-0"
            >
              <a href="https://www.instagram.com/DelvnReyes">
                <AiFillInstagram />
              </a>

              <a href="https://twitter.com/DelvnReyes">
                <AiFillTwitterCircle />
              </a>

              <a href="https://www.linkedin.com/in/delvinreyes/">
                <AiFillLinkedin />
              </a>

              <a href="https://github.com/DelvinReyes95">
                <AiFillGithub />
              </a>
            </motion.div>
          </div>

          <motion.div
            variants={fadeIn("down", 0.5)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.7 }}
            className="hidden lg:flex flex-1 max-w-[320px] lg:max-w-[320px] w-[250px] h-[250px] sm:w-[350px] sm:h-[330px] rounded-full overflow-hidden shadow-heroSadow border-[0px] bg-gradient-to-r from-gray-200 via-gray-400 to-gray-600"
          >
            <img src={Image} alt="" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Home;

//sm:w-[320px]
